import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeIsvSourceId: (value: string) => void;
}

const IsvSourceIdField: React.FC<IProps> = ({ changeIsvSourceId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{
				validator(_, value) {
					if (!value || value.length === 0 || value.length === 4) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('theValueMustContainNumberOfCharacters', { value: '4' })));
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeIsvSourceId(onlyDigits);
			return onlyDigits;
		},
		[changeIsvSourceId],
	);

	return (
		<FormInput
			testId="IsvSourceIdField"
			name="isvSourceId"
			label="isvSourceIdLabel"
			maxLength={4}
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(IsvSourceIdField);
